import { toDate } from 'date-fns';
import { CREDIT_SELECTION_ABC_EXPERIMENT_IDS, FORM_FIELDS, PAGE, UTM_MARKS } from '../../../../constants';
import analytics from '../../../../helpers/analytics';
import { postMessage, PostMessageType } from '../../../../helpers/whitelable';
import { getScoring, scoringToFormData } from '../../../../helpers/form.new/tasks/get.scoring';
import { getStore } from '../../../../store/client';
import { extendFormData } from '../../../../store/reducers/formStore';
import { dateDiffYears, dateStringToTimestamp, sourceNameByValue } from '../../../../helpers';
import { checkListOfAbExperimentVariant } from '../../../../helpers/experiments';
import { EDUCATION_SOURCE, FAMILY_STATUS_SOURCE, SENIORITY_PERIODS } from '../../../../constants/sources';
import { getAddress } from '../../../../helpers/form.new/tasks/get.address';
import { marksSelector } from '../../../../store/reducers/utmMarks';

export { PassportStepView } from './view';
export { schema } from './schema';

export const onNext = async () => {
    const { withoutAnalytics, page, formData, autoRun } = getStore().getState().formStore;
    const { dispatch } = getStore();
    const { experiments } = getStore().getState().abData;
    const marks = getStore().getState().utmMarks;
    const { [UTM_MARKS.MEDIUM]: utmMedium } = marksSelector(marks);
    const [isShowFocusedView] = checkListOfAbExperimentVariant(experiments, page, utmMedium, [
        {
            name: CREDIT_SELECTION_ABC_EXPERIMENT_IDS.NEW_FOCUSED_FORM,
            value: '1',
        },
    ]);

    if ([PAGE.WHITELABEL, PAGE.WAYBACK].includes(page as any)) {
        postMessage({
            type: PostMessageType.framePageCompleted,
            result: { page_number: 2 },
        });
    }

    if (page == PAGE.AVITO) {
        postMessage({
            type: PostMessageType.event,
            label: 'broker_form_passport_submit',
        });
    }

    if (!withoutAnalytics) {
        const fillType = autoRun ? 'Проброс' : 'Ручное';
        analytics.emit({
            event: analytics.events.mainEvent,
            eventCategory: [PAGE.CARDS_RESTORE].includes(page as any)
                ? analytics.categories.CreditCard
                : analytics.categories.Loan,
            eventAction: isShowFocusedView ? 'Шаг 3|Место работы' : 'Шаг 2|Паспорт',
            eventLabel: [
                fillType,
                `Образование - ${sourceNameByValue(formData[FORM_FIELDS.EDUCATION], EDUCATION_SOURCE)}`,
                `Семейное положение - ${sourceNameByValue(formData[FORM_FIELDS.FAMILY_STATUS], FAMILY_STATUS_SOURCE)}`,
            ].join('|'),
        });
    }

    const results = await Promise.allSettled([getScoring(formData), getAddress(formData)]);

    const scoringResult = results[0].status === 'fulfilled' ? results[0].value : undefined;
    const addressResult = results[1].status === 'fulfilled' ? results[1].value : undefined;

    const { score, scoreType } = scoringResult || {};

    if (!withoutAnalytics) {
        const model = scoreType === 'gen7' ? 'score_point_ekvifax' : 'score_point_gen7_cl';
        analytics.emit({
            event: analytics.events.mainEvent,
            eventCategory: analytics.categories.Loan,
            eventAction: 'Показ скорбалла',
            eventLabel: [`${model} - ${score ? Math.floor(score as number) : 'Не найден'}`].join('|'),
        });
    }

    dispatch(
        extendFormData({
            ...(scoringResult ? scoringToFormData(scoringResult) : {}),
            ...(addressResult || {}),
        }),
    );

    const birthdayValue = formData[FORM_FIELDS.BIRTHDAY];
    if (birthdayValue) {
        const years = dateDiffYears(new Date(), toDate(dateStringToTimestamp(birthdayValue))) - 18;
        const seniority = SENIORITY_PERIODS.find((item) => {
            return (
                (item.period.from === null || item.period.from <= years) &&
                (item.period.to === null || years < item.period.to)
            );
        });
        getStore().dispatch(extendFormData({ [FORM_FIELDS.SENIORITY]: seniority?.value || '' }));
    }

    return true;
};
